import { defineComponent as _defineComponent } from 'vue';
import { cva } from 'class-variance-authority';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ItemMedia',
    props: {
        variant: { type: String, required: false, default: 'default' },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const mediaVariants = cva('shrink-0 flex items-center justify-center', {
            variants: {
                variant: {
                    default: 'size-10',
                    icon: 'size-10 rounded-md bg-secondary text-secondary-foreground',
                    image: 'size-10 rounded-md overflow-hidden',
                },
            },
            defaultVariants: {
                variant: 'default',
            },
        });
        const __returned__ = { props, mediaVariants, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
